import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { Auth } from './../Auth';
import { AutenticationService } from './../autentication.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Component, OnInit, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { AutenticationEventType } from '../autentication.event.type';
import { TweenMax, Sine, Quint } from 'gsap';
import { AuthMessage } from '../models/auth-message';
import { EventTypes } from '../../shared/EventTypes';


@Component({
	selector: 'app-redefine-password',
	templateUrl: './redefine-password.component.html',
	styleUrls: ['./redefine-password.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class RedefinePasswordComponent implements OnInit, OnDestroy {

	// strengthPass = new RegExp( /^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9]).{8,}$/ );
	form: FormGroup;
	canSend = false;
	loading = false;
	active = false;
	passDone = false;
	passError = false;
	passConfirmDone = false;
	passConfirmError = false;
	inputToKeypadSendValue: any;
	disabled = false;

	constructor(private authService: AutenticationService , private formBuilder: FormBuilder) {

		this.form = formBuilder.group({
			'pass': ['', Validators.compose([Validators.required, Validators.pattern(new RegExp(/[0-9]{6,6}/))])],
			'confirmPass': ['', Validators.compose([Validators.required, Validators.pattern(new RegExp(/[0-9]{6,6}/))])]
		});

		AppEventDispatcher.listen( AutenticationEventType.LOGIN.REDEFINE_PASSWORD, () => {
			this.show();
		});
	}

	ngOnInit() {
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener( AutenticationEventType.LOGIN.REDEFINE_PASSWORD );
	}

	onSend() {

		if (this.form.valid && !this.loading && (this.form.controls.pass.value === this.form.controls.confirmPass.value)) {
			this.loading = true;
			this.disabled = true;

			this.authService.alterPass(this.form.controls.pass.value, Auth.cpf).subscribe( () => {

				this.hide();

				Auth.tempPass = this.form.controls.pass.value;

				const message = new AuthMessage();
				
				if (Auth.defineSignature) {
					AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.DEFINE_SUBSCRIBE, null);
				} else {
					message.buttonTitle = 'Acessar';
					message.delay = .2;
					message.eventToDispatch = AutenticationEventType.LOGIN.LOGIN;
					message.eventData = { fromDefinePassword: true };
					message.delayToDispatchEvent = 0;
					message.hasButton = true;
					message.title = 'Sua senha foi redefinida com sucesso!';
					message.text = 'A partir de agora, esta será a sua senha para acessar a sua conta.';
					message.withPreload = true;
					this.disabled = false;

					AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.AUTH_MESSAGE, message);
				}

			}, error => {

				this.loading = false;
				this.disabled = false;

				if (error.status === 400) {
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
				} else if (error.status === 500) {
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'Ocorreu um erro no servidor, tente novamente.' });
				} else if (error.error.Mensagem) {
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
				}
			});

		}

	}

	show() {
		this.active = true;
		this.inputToKeypadSendValue = this.form.controls.pass;

		TweenMax.delayedCall(.1, () => {
			TweenMax.to('[data-component="redefine-password"]', .8, { delay: .5, left: 0, ease: Quint.easeOut});
		});
	}

	hide() {
		TweenMax.to('[data-component="redefine-password"]', .8, { left: '-100%', ease: Quint.easeOut, onComplete: () => {
			this.loading = false;
			this.active = false;
			this.form.controls.pass.reset();
			this.form.controls.confirmPass.reset();
		}});
	}

	setInputValueFromKeyPad(val) {

		if (this.inputToKeypadSendValue.value.length < 6) {
			this.inputToKeypadSendValue.setValue(this.inputToKeypadSendValue.value.toString() + val[0].toString());
		}

		this.inputToKeypadSendValue.updateValueAndValidity();

		if (this.form.valid && (this.form.controls.pass.value === this.form.controls.confirmPass.value)) {
			this.canSend = true;
		} else {
			this.canSend = false;
		}

		if (this.inputToKeypadSendValue === this.form.controls.pass) {
			this.validatePass();
		} else {
			this.validateConfirmPass();
		}

	}

	changeToConfirm() {
		$('[data-component="redefine-password"]').find('.confirm-input').focus();
		this.inputToKeypadSendValue = this.form.controls.confirmPass;
		this.validatePass();
	}

	keyDownHandler(event: Event) {
		event.preventDefault();
	}

	onCorrect() {
		this.inputToKeypadSendValue.setValue('');
	}

	inputFocus(input) {
		this.inputToKeypadSendValue = input;
	}

	validatePass() {

		if (this.form.controls.pass.valid) {
			this.passDone = true;
			this.passError = false;
		} else {
			this.passError = true;
			this.passDone = false;
		}
	}

	validateConfirmPass() {

		if (this.form.controls.confirmPass.valid && (this.form.controls.pass.value === this.form.controls.confirmPass.value)) {
			this.passConfirmDone = true;
			this.passConfirmError = false;
		} else {
			this.passConfirmError = true;
			this.passConfirmDone = false;
		}
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/autentication/redefine-password/redefine-password.component.ts